export const onlineSignups = [
    {month: 'Jan', count: 800},
    {month: 'Feb', count: 1600},
    {month: 'Mar', count: 1100},
    {month: 'Apr', count: 2600},
    {month: 'May', count: 1900},
    {month: 'Jun', count: 3200},
];
